/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { Flag } from 'ui/atoms/Flag/Flag';
import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './SanctionsCoverage.module.scss';

import type { CoverageCard, CoverageListRow, SanctionsCoverageProps } from './SanctionsCoverage.types';

const RowMark = ({ row }: { row: CoverageListRow }) => {
  if (row.code) {
    return (
      <span className={styles.mark}>
        <Flag code={row.code} rounded />
      </span>
    );
  }

  return (
    <span className={cn(styles.mark, styles.markIcon)}>
      <Icon type={row.icon ?? 'compliance-1'} />
    </span>
  );
};

const Card = ({ card }: { card: CoverageCard }) => (
  <div className={styles.card}>
    <h3 className={styles.cardTitle}>{card.title}</h3>
    <div className={styles.cardSub}>{card.sub}</div>

    {card.variant === 'lists' && (
      <div className={styles.list}>
        {card.rows.map((row) => (
          <div key={row.label} className={styles.row}>
            <RowMark row={row} />
            <div>
              <b>{row.label}</b>
              <span>{row.desc}</span>
            </div>
          </div>
        ))}
      </div>
    )}

    {card.variant === 'tiers' && (
      <>
        <div className={styles.tiers}>
          {card.tiers.map((tier) => (
            <div key={tier.badge} className={cn(styles.tier, styles[`tier_${tier.tone}`])}>
              <b>{tier.badge}</b>
              <span>{tier.text}</span>
            </div>
          ))}
        </div>

        <div className={styles.notes}>
          {card.notes.map((note) => (
            <span key={note} className={styles.note}>
              {note}
            </span>
          ))}
        </div>
      </>
    )}

    {card.variant === 'stats' && (
      <div className={styles.stats}>
        {card.stats.map((stat) => (
          <div key={stat.label} className={styles.stat}>
            <b>{stat.value}</b>
            <span>{stat.label}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);

export const SanctionsCoverage = ({ cards, className }: SanctionsCoverageProps) => (
  <div className={cn(styles.grid, className)}>
    {cards.map((card) => (
      <Card key={card.title} card={card} />
    ))}
  </div>
);
